import { render, staticRenderFns } from "./SimpleLsForm.vue?vue&type=template&id=8598a7b2&"
import script from "./SimpleLsForm.vue?vue&type=script&lang=ts&"
export * from "./SimpleLsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports